import React, { useEffect,useState, useRef } from 'react';
import { Rating } from 'primereact/rating';
import { Tag } from 'primereact/tag';
import { SplitButton } from 'primereact/splitbutton';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { InputText } from 'primereact/inputtext';
import { FloatLabel } from "primereact/floatlabel";
import { Dialog } from 'primereact/dialog';
import ProductDetails from '../ProductDetails'

const ListViewProductItemCard = ({index, itemId,category, name, inventoryStatus, productImage, rating, sellingPrice }) => {
    const toast = useRef(null);

    const [categories, setCategories] = useState([]);

    const [productUpdatePopupVisible, setProductUpdatePopupVisible] = useState(false);
    const [productDetailsPopupVisible,setProductDetailsPopupVisible] = useState(false);
    const [productDeletionPopupVisible, setProductDeletionPopupVisible] = useState(false);
    

    const [itemName, setItemName] = useState("");
    const [description, setDescription] = useState("");
    const [image, setImage] = useState(null);
    const [size, setSize] = useState("Small");
    const [color, setColor] = useState("Black");
    const [material, setMaterial] = useState("");
    const [quantity, setQuantity] = useState(0);
    const [productSellingPrice, setProductSellingPrice] = useState(0);
    const [purchasePrice, setPurchasePrice] = useState(0);
    const [currency, setCurrency] = useState("GBP");
    const [isTaxable, setIsTaxable] = useState(false);
    const [taxRate, setTaxRate] = useState(0);
    const [sellerDescription, setSellerDescription] = useState("");
    const [warrantyDetails, setWarrantyDetails] = useState("");


    useEffect( ()=>{
        setCategories(category);
    },[]);


    const saveItem = () => {
        setProductUpdatePopupVisible(false);
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Details saved', life: 3000 });
    };

    const deleteItem = () => {
        toast.current.show({ severity: 'warn', summary: 'Delete', detail: 'Data Deleted', life: 2000  });
    };

    const viewProductDetails = () => {
        setProductDetailsPopupVisible(true);
    };



    const getSeverity = (inventoryStatus) => {
        switch (inventoryStatus) {
            case 'INSTOCK':
                return 'success';
            case 'LOWSTOCK':
                return 'warning';
            case 'OUTOFSTOCK':
                return 'danger';
            default:
                return null;
        }
    };

    const save = () => {
        toast.current.show({ severity: 'success', summary: 'Success', detail: 'Data Saved' });
    };

    const items = [
        {
            label: 'Update',
            icon: 'pi pi-refresh',
            command: () => {
                setProductUpdatePopupVisible(true);
            }
        },
        {
            label: 'Delete',
            icon: 'pi pi-times',
            command: () => {
                setProductDeletionPopupVisible(true);
            }
        },
    ];
  
    return (
    <div className="col-12" key={itemId}>
    <div className={classNames('flex flex-column xl:flex-row xl:align-items-start p-4 gap-4', { 'border-top-1 surface-border': index !== 0 })}>
        <img className="w-9 sm:w-16rem xl:w-10rem shadow-2 block xl:block mx-auto border-round" src={`data:image/jpeg;base64,${productImage}`} alt={name} />
        <div className="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
            <div className="flex flex-column align-items-center sm:align-items-start gap-3">
                <div className="text-2xl font-bold text-900">{name}</div>
                <Rating value={rating} readOnly cancel={false}></Rating>
                <div className="flex align-items-center gap-3">
                    <span className="flex align-items-center gap-2">
                        <i className="pi pi-tag"></i>
                        <span className="font-semibold">{categories.name}</span>
                    </span>
                    <Tag value={inventoryStatus} severity={getSeverity(inventoryStatus)}></Tag>
                </div>
            </div>
            <div className="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
                <span className="text-2xl font-semibold">£{sellingPrice}</span>
                <Toast ref={toast}></Toast>
                <SplitButton label="View" icon="pi pi-eye" onClick={viewProductDetails} model={items} />
                </div>
        </div>
    </div>

    <Dialog header="Update Product details" visible={productUpdatePopupVisible} style={{ width: '50vw' }} onHide={() => {if (!productUpdatePopupVisible) return; setProductUpdatePopupVisible(false); }}>
                <p className="m-0">
                  <br/>                  <br/>
                  <br/>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex-auto">
                  <FloatLabel>
                    <InputText id="productName" value={itemName} onChange={(e) => setItemName(e.target.value)} tooltip="Enter your username" tooltipOptions={{ position: 'top' }}/>
                    <label htmlFor="productName">Product name</label>
                  </FloatLabel>
                </div><br/>
                <div className="flex-1">
                  <FloatLabel>
                    <InputText id="description" value={description} onChange={(e) => setDescription(e.target.value)} tooltip="Enter your username" tooltipOptions={{ position: 'top' }}/>
                    <label htmlFor="description">Description</label>
                  </FloatLabel>
                </div>
                <div className="flex-auto">
                  <FloatLabel>
                    <InputText id="image" value={image} onChange={(e) => setImage(e.target.value)} tooltip="Enter your username" tooltipOptions={{ position: 'top' }} />
                    <label htmlFor="image">Image</label>
                  </FloatLabel>
                </div>
                <div className="flex-auto">
                  <FloatLabel>
                    <InputText id="size" value={size} onChange={(e) => setSize(e.target.value)} tooltip="Enter your username" tooltipOptions={{ position: 'top' }} />
                    <label htmlFor="size">Size</label>
                  </FloatLabel>
                </div>
                <div className="flex-auto">
                  <FloatLabel>
                    <InputText id="color" value={color} onChange={(e) => setColor(e.target.value)} tooltip="Enter your username" tooltipOptions={{ position: 'top' }} />
                    <label htmlFor="color">Color</label>
                  </FloatLabel>
                </div>
                <div className="flex-auto">
                  <FloatLabel>
                    <InputText id="material" value={material} onChange={(e) => setMaterial(e.target.value)} tooltip="Enter your username" tooltipOptions={{ position: 'top' }} />
                    <label htmlFor="material">Material</label>
                  </FloatLabel>
                </div>
                <div className="flex-auto">
                  <FloatLabel>
                    <InputText id="quantity" value={quantity} onChange={(e) => setQuantity(e.target.value)} tooltip="Enter your username" tooltipOptions={{ position: 'top' }} />
                    <label htmlFor="quantity">Quantity</label>
                  </FloatLabel>
                </div>
                <div className="flex-auto">
                  <FloatLabel>
                    <InputText id="sellingPrice" value={productSellingPrice} onChange={(e) => setProductSellingPrice(e.target.value)} tooltip="Enter your username" tooltipOptions={{ position: 'top' }} />
                    <label htmlFor="sellingPrice">Selling Price</label>
                  </FloatLabel>
                </div>
                <div className="flex-auto">
                  <FloatLabel>
                    <InputText id="purchasePrice" value={purchasePrice} onChange={(e) => setPurchasePrice(e.target.value)} tooltip="Enter your username" tooltipOptions={{ position: 'top' }} />
                    <label htmlFor="purchasePrice">Purchase Price</label>
                  </FloatLabel>
                </div>
                <div className="flex-auto">
                  <FloatLabel>
                    <InputText id="currency" value={currency} onChange={(e) => setCurrency(e.target.value)} tooltip="Enter your username" tooltipOptions={{ position: 'top' }} />
                    <label htmlFor="currency">Currency</label>
                  </FloatLabel>
                </div>
                <div className="flex-auto">
                  <FloatLabel>
                    <InputText id="isTaxable" value={isTaxable} onChange={(e) => setIsTaxable(e.target.value)} tooltip="Enter your username" tooltipOptions={{ position: 'top' }} />
                    <label htmlFor="isTaxable">Is Taxable</label>
                  </FloatLabel>
                </div>
                <div className="flex-auto">
                  <FloatLabel>
                    <InputText id="taxRate" value={taxRate} onChange={(e) => setTaxRate(e.target.value)} tooltip="Enter your username" tooltipOptions={{ position: 'top' }} />
                    <label htmlFor="taxRate">Tax Rate</label>
                  </FloatLabel>
                </div>
                <div className="flex-auto">
                  <FloatLabel>
                    <InputText id="sellerDescription" value={sellerDescription} onChange={(e) => setSellerDescription(e.target.value)} tooltip="Enter your username" tooltipOptions={{ position: 'top' }} />
                    <label htmlFor="sellerDescription">Seller Description</label>
                  </FloatLabel>
                </div>
                <div className="flex-auto">
                  <FloatLabel>
                    <InputText id="warrantyDetails" value={warrantyDetails} onChange={(e) => setWarrantyDetails(e.target.value)} tooltip="Enter your username" tooltipOptions={{ position: 'top' }} />
                    <label htmlFor="warrantyDetails">Warranty Details</label>
                  </FloatLabel>
                </div>
              </div>
              <br/>                        <br/>
              <br/>
                        <div className="flex align-items-center gap-2 mt-4">
                            <Button
                                label="Save"
                                onClick={() => {
                                    saveItem();
                                }}
                                className="w-8rem"
                            ></Button>
                            <Button
                                label="Cancel"
                                outlined
                                onClick={() => {
                                    setProductUpdatePopupVisible(false);
                                }}
                                className="w-8rem"
                            ></Button>
                        </div>
                  
                </p>
            </Dialog>

            <Dialog header="View Item" visible={productDetailsPopupVisible} style={{ width: '80vw' }} onHide={() => {if (!productDetailsPopupVisible) return; setProductDetailsPopupVisible(false); }}>
                <ProductDetails productId={itemId} description={description} category={categories} itemId={itemId} name={name} inventoryStatus={inventoryStatus} productImage={productImage} rating={rating} sellingPrice={sellingPrice}/>
            </Dialog>
            <ConfirmDialog group="declarative"  visible={productDeletionPopupVisible} onHide={() => setProductDeletionPopupVisible(false)} message="Are you sure you want to delete?" 
                header="Confirmation" icon="pi pi-exclamation-triangle" accept={deleteItem} />
</div>
  )
}

export default ListViewProductItemCard
